// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/time-zones.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/time-zones/utc-local.js';

mount([g0]);
